import React from 'react';
import moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@cargomatic/ui';
import AppointmentPicker from 'components/ui/tailwind/AppointmentPicker';

export default function LaneRatesAppointmentWindowModal({
  show,
  onClose,
  validity,
  onStartChange,
  onEndChange,
}) {
  const { t } = useTranslation();

  const startTime = validity.effectiveStart
    ? moment(validity.effectiveStart)
    : null;
  const endTime = validity.effectiveEnd ? moment(validity.effectiveEnd) : null;
  const start = startTime && startTime.isValid() ? startTime : null;
  const end = endTime && endTime.isValid() ? endTime : null;

  return (
    <Dialog
      open={show}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{t('LANE_RATE_VALIDITY')}</DialogTitle>
        </DialogHeader>
        <div className="flex justify-center">
          <AppointmentPicker
            dataTestId="AppointmentPicker-43b48f7f"
            start={start}
            end={end}
            confirmed={false}
            onStartChange={onStartChange}
            onEndChange={onEndChange}
            onToggleConfirmed={() => {}}
            hideConfirm={onClose}
          />
        </div>
        <DialogFooter>
          <Button onClick={onClose}>{t('DONE')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
